import React from 'react';

import styled from '@emotion/styled';

import LeftCheveron from '../Icons/LeftCheveron';
import { SpinningIcon } from '../SpinningIcon/SpinningIcon';
import { IButton } from './interface';

const PrimaryButton: React.FC<IButton> = ({
  children,
  className,
  arrowIcon,
  onClick,
  disabled = false,
}) => {
  return (
    <StyledButton
      className={className ? className : ''}
      onClick={onClick}
      disabled={disabled}
    >
      {children} {arrowIcon && <LeftCheveron />}
    </StyledButton>
  );
};

export default PrimaryButton;

const StyledButton = styled.button`
  color: ${({ theme }) => theme.palette.white};
  border: 1px solid transparent;
  border-radius: 0.5rem;
  padding: 1rem 2.5rem 1rem 2.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  background: ${({ theme }) => theme.palette.primaryshades5};
  width: 100%;

  &:disabled {
    background-color: #fab89e;
    cursor: not-allowed;
  }

  @media (max-width: 480px) {
    width: 100%;
  }

  &.fitContent {
    width: fit-content;

    @media (max-width: 480px) {
      width: fit-content;
    }
  }
`;

interface IFormSubmitButton {
  iconColor?: string;
  iconSize?: string;
  showIcon?: boolean;
  children: string;
  width?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  cheveronIcon?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

export const FormSubmitButton: React.FC<IFormSubmitButton> = ({
  iconColor,
  iconSize,
  showIcon,
  children,
  className,
  type,
  disabled,
  onClick,
  cheveronIcon,
  width,
}) => {
  return (
    <FormSubmitBtn
      type={type}
      disabled={disabled}
      className={className ? className : ''}
      onClick={onClick}
    >
      {children} {cheveronIcon && <LeftCheveron />}
      {showIcon ? (
        <SpinningIcon color={iconColor || 'white'} size={Number(iconSize)} />
      ) : (
        ''
      )}
    </FormSubmitBtn>
  );
};

export const FormSubmitBtn = styled.button`
  background: ${({ theme }) => theme.palette.primaryshades5};
  font-weight: 700;
  font-size: 1rem;
  color: white;
  border: 1px solid transparent;
  cursor: pointer;

  /* for the spinner */
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  width: fit-content;
  border-radius: 0.25rem;
  padding: 1rem 1.5rem;
  width: 100%;
  margin-top: 2rem;

  /*  */
  &.placeLeft {
    width: fit-content;
    margin-left: auto;
  }
`;

export const FilterButton = styled.button`
  background-color: ${({ theme }) => theme.palette.brandPrimary};
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: white;
  border-radius: 0.25rem;
  border: 2px solid transparent;
  cursor: pointer;
`;

interface IIconButton {
  disabled?: boolean;
  onClick?: (...args: any) => void;
  iconColor?: string;
  iconSize?: string;
  showIcon?: boolean;
  children: any;
  width?: string;
}

export const Button: React.FC<IIconButton> = ({
  children,
  onClick,
  disabled = false,
}) => {
  return (
    <IconButton
      type="submit"
      disabled={disabled}
      onClick={onClick}
      className={disabled === true ? 'not-allowed' : ''}
    >
      {children}
    </IconButton>
  );
};

interface IStyledButton {
  width?: string;
  bgColor?: string;
  bgHoverColor?: string;
  textColor?: string;
  textHoverColor?: string;
  border?: string;
  cursor?: string;
  fontSize?: string;
}

export const IconButton = styled.button<IStyledButton>`
  background-color: transparent;
  border: 2px solid transparent;
  border-radius: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${({ cursor }) => (cursor ? cursor : 'pointer')};
  padding: 0;

  &:focus {
    outline: none;
  }

  &.not-allowed {
    cursor: not-allowed;
  }

  &.not-allowed > svg {
    cursor: not-allowed;
  }
`;
